import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import Element from '../services/Element.js'

import '../../css/ElementShortcuts.css';

class ElementShortcuts extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      element: props.element,
      type: props.type,
      userData: props.userData
    }
  }

  componentWillReceiveProps(newProps) {
    this.state = {
      element: newProps.element,
      type: newProps.type,
      userData: newProps.userData
    }
  }

  render() {

    let type = this.state.type;
    let element = this.state.element;
    let userData = this.state.userData;

    let mapUrl = Element.mapUrl(type, element);
    let riverUrl = Element.riverUrl(type, element);
    let treemapUrl = Element.treemapUrl(type, element);
    let lastfmUrl = Element.lastfmUserUrl(type, element);
    let userLibraryUrl = Element.userLibraryUrl(type, userData);

    if (type === 'user' && element.artistsCount <= 2) {
      return (<ul></ul>);
    }

    return (
      <ul className="menu">

        {lastfmUrl && <li>
          <a href={lastfmUrl} target="_blank">
            <i title="Go to last.fm user page" className="fontastic icon-info clickable"></i>
          </a>
        </li>}

        {mapUrl && <li>
          <Link to={mapUrl}>
            <i title="Go to similarity map" className="fontastic icon-map clickable"></i>
          </Link>
        </li>}

        {riverUrl && <li>
          <Link to={riverUrl}>
            <i title="Go to listening habits" className="fontastic icon-river clickable"></i>
          </Link>
        </li>}

        {treemapUrl && <li>
          <Link to={treemapUrl}>
            <i title="Go to treemap" className="fontastic icon-tree clickable"></i>
          </Link>
        </li>}

        {userLibraryUrl && <li>
          <Link to={userLibraryUrl}>
            <i title="See in your library" className="fontastic icon-library clickable"></i>
          </Link>
        </li>}

        </ul>
    );
  }

}

export default ElementShortcuts;



// WEBPACK FOOTER //
// ./src/js/components/ElementShortcuts.jsx